import createSupabaseStore from './supabase-table-store'

const delay = async (time, val, shouldReject = false) => new Promise((resolve, reject) => setTimeout(_ => shouldReject ? reject(val) : resolve(val), time));

export default () => createSupabaseStore(
  async (set, supabase, payload) => {
    await delay(200);

    const {data} = await supabase
      .from('projects_view')
      .select('*')
      .eq('main', true)
    ;

    set(data && data.length ? data[0] : null);
  },
  'projects'
);